import React, { useState } from 'react'

import { CancelConfirmButtons, DownloadIcon, Typography } from '@astrid/components'

import styles from './UploadClassModal.module.scss'
import XLSXInput from './XLSXInput'

const XLSX_TEMPLATE_DOWNLOAD_URL = 'https://static-production.withastrid.com/static/Student_List_Template.xlsx'

interface UploadClassModalProps {
  closeModal: (flag: boolean) => void
  onFileUpload: (file: File) => void
}

const UploadClassModal = ({ closeModal, onFileUpload }: UploadClassModalProps) => {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null)
  return (
    <div className={styles.container}>
      <Typography variant="h2">Upload class list</Typography>
      <div className={styles.uploadStep}>
        <Typography variant="h4">Step 1</Typography>
        <Typography variant="body">
          Download the Excel template below and fill it with your students' details.
        </Typography>
        <div>
          <a download href={XLSX_TEMPLATE_DOWNLOAD_URL}>
            <DownloadIcon aria-hidden="true" focusable="false" />
            Download template (XLSX)
          </a>
        </div>
      </div>
      <div className={styles.uploadStep}>
        <Typography variant="h4">Step 2</Typography>
        <Typography variant="body">Upload the completed XLSX template (ensure the file format is .XLSX):</Typography>
        <XLSXInput onFileUpload={setUploadedFile} />
      </div>
      <CancelConfirmButtons
        confirmText="Add students"
        onCancel={() => closeModal(false)}
        disableConfirm={!uploadedFile}
        onConfirm={() => onFileUpload(uploadedFile!)}
      />
    </div>
  )
}

export default UploadClassModal
